<template>
  <div class="menu-page">
    <div>
      <dashboard-nav></dashboard-nav>
      <div class="d-flex bodyWrapper">
        <div class="nav-view">
          <main-nav></main-nav>
        </div>

        <!-- VIEW START -->
        <div class="main-view" v-if="dataReady">
          <breadcrumb :crumb="name"></breadcrumb>
          <div class="intro-wrapper main-x-spacing">
            <h2>{{ title }}</h2>
            <v-row>
              <v-col cols="10">
                <v-text-field
                  v-model="searchQuery"
                  prepend-inner-icon="search"
                  label="Search Currency"
                  class="toWhite"
                  flat
                  hide-details
                  single-line
                  solo
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn
                  :ripple="false"
                  @click="openAddCurrency"
                  depressed
                  style="min-width: 100px; max-width: 100%"
                  class="gen-button white--text flex-grow-1 flex-shrink-0"
                  color="#60a45f"
                >
                  <v-icon>add</v-icon>
                  <span>Add New Currency</span>
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <!-- main view -->
          <div class="main-body-content main-x-spacing">
            <v-row>
              <v-col cols="12">
                <div class="table-menu">
                  <v-data-table
                    :headers="headers"
                    :items="filteredSearchResult"
                    item-key="id"
                    class="elevation-0 dataTableUI staffTable border-me-light"
                  >
                    <!-- For Actions -->
                    <template v-slot:[`item.action`]="{ item }">
                      <div class="d-flex justify-space-between">
                        <v-btn
                          :ripple="false"
                          x-small
                          text
                          class="white py-4 btn-outlined"
                          @click="deleteCurrency(item.id)"
                          ><v-icon>delete_forever</v-icon></v-btn
                        >
                      </div>
                    </template>
                  </v-data-table>
                </div>
              </v-col>
            </v-row>
          </div>
          <!-- Upload List -->
          <v-row justify="center" class="openDialogWrapper">
            <v-dialog
              v-model="openDialog"
              fullscreen
              max-width="50%"
              transition="scroll-x-reverse-transition"
              class="openDialog"
            >
              <v-card
                max-width="50%"
                tile
                class="ml-auto dialogCard"
                height="100%"
              >
                <!-- Add New Currency -->
                <div v-if="addNewCurrencyActive" class="formLayerCard">
                  <h2 class="dialog-form-title">Add Currency</h2>
                  <v-form ref="dialogForm" class="dialog-form">
                    <v-row v-if="addNewCurrencyActive">
                      <v-col style="position: relative" cols="12">
                        <v-select
                          v-model="currency"
                          outlined
                          :rules="[rules.required]"
                          :items="defCurrencies"
                          item-text="name"
                          return-object
                          :menu-props="{ offsetY: true }"
                          dense
                          label="Currency"
                          class="v-text-field"
                          required
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-form>

                  <div class="dialogAction text-right">
                    <v-btn
                      :ripple="false"
                      @click="openDialog = false"
                      class="grey--text mr-3"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      :loading="loader"
                      :ripple="false"
                      color="#468346"
                      class="white--text"
                      @click="addNewCurrency"
                    >
                      <span>Ok</span>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-dialog>
          </v-row>
        </div>
        <inner-page-loader v-else class="main-view"></inner-page-loader>
      </div>
    </div>

    <!-- Snackbar Notification -->
    <v-snackbar
      class="snackbar"
      :color="snackBar.color"
      bottom
      right
      v-model="snackBar.active"
      :multi-line="snackBar.multiLine"
      :timeout="snackBar.timeout"
      >{{ snackBar.text }}</v-snackbar
    >
  </div>
</template>

<script>
import dashboard_Nav from "@/components/dashboard-nav";
import main_Nav from "@/components/mainNav";
import bread_crumb from "@/components/breadcrumb";
import inner_page_loader from "@/components/innerPageLoader";
import { mapGetters, mapState } from "vuex";

import axios from "axios";

export default {
  data() {
    return {
      title: "Currencies",
      dataReady: false,
      loader: false,
      deleteLoader: false,
      loaderNum: -1,
      name: "",
      openDialog: false,
      addNewCurrencyActive: false,
      headers: [
        {
          text: "Currency Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: "Currency Code",
          align: "start",
          sortable: false,
          value: "code",
        },
        {
          text: "Currency Symbol",
          align: "start",
          sortable: true,
          value: "symbol",
        },
        {
          text: "Action",
          align: "center",
          justify: "space-between",
          sortable: false,
          width: 133,
          value: "action",
        },
      ],
      newCurrencies: [{ name: "" }, { name: "" }],
      currency: "",
      rules: {
        required: (value) => !!value || "Required",
        numberMax15: (value) =>
          !value ||
          (/^[0-9]*$/.test(value) && value.length < 16) ||
          "Must by phone digit (Max. 15)",
        number: (value) => !value || /^[0-9]*$/.test(value) || "Invalid value",
      },
      snackBar: {
        active: false,
        text: "",
        color: "",
        multiLine: "",
        timeout: null,
      },
      searchQuery: "",
    };
  },
  methods: {
    deleteCurrency(id) {
      //   Start Loader
      this.deleteLoader = true;

      axios
        .delete("/api/v1/currency/" + id, {
          headers: { Authorization: this.$store.state.token },
        })
        .then(() => {
          // Refresh cancellation Coupons
          this.$store.dispatch("getAllCurrencies");

          //   Stop Loader
          this.deleteLoader = false;

          this.snackBar.active = true;
          this.snackBar.text = "Currency Deleted";
          this.snackBar.color = "success";
          this.snackBar.timeout = this.$store.state.snackBarDuration;
        })
        .catch((error) => {
          //   Stop Loader
          this.deleteLoader = false;

          this.snackBar.active = true;
          this.snackBar.text =
            error.response.data.message || "Error deleting currency";
          this.snackBar.color = "success";
          this.snackBar.timeout = this.$store.state.snackBarDuration;
        });
    },
    openAddCurrency() {
      this.addNewCurrencyActive = true;
      this.openDialog = true;
    },
    addNewCurrency() {
      if (this.$refs.dialogForm.validate()) {
        this.loader = true;
        let route = "/api/v1/currency/";
        let reqType = "post";

        // extract necessary data from seleceted currency
        const data = (({ name, code, symbol }) => ({ name, code, symbol }))(
          this.currency
        );

        axios({
          method: reqType,
          url: route,
          data: data,
          headers: { Authorization: this.$store.state.token },
        })
          .then(() => {
            // Refresh Currency
            this.$store.dispatch("getAllCurrencies");
            this.loader = false;

            // Reset Currency form
            this.openDialog = false;
          })
          .catch((error) => {
            this.loader = false;

            this.snackBar.active = true;
            this.snackBar.text =
              error.response.data.message || "Error adding currency";
            this.snackBar.color = "error";
            this.snackBar.timeout = this.$store.state.snackBarDuration;
          });
      }
    },
  },
  watch: {
    allEntCurrencies(val) {
      if (val) {
        // stop page loader when data is ready
        this.dataReady = true;
      }
    },
    openDialog(val) {
      if (val == false) {
        this.addNewCurrencyActive = false;
        this.$refs.dialogForm.reset();
      }
    },
  },
  async created() {
    this.$store.dispatch("getAllCurrencies");
    this.$store.dispatch("getAllCurrencies");
  },
  computed: {
    filteredSearchResult() {
      try {
        let grabArr = this.allEntCurrencies;

        return grabArr.filter((item) => {
          if (
            item.name.toLowerCase().indexOf(this.searchQuery.toLowerCase()) !==
              -1 || // search by name
            item.code.toLowerCase().indexOf(this.searchQuery.toLowerCase()) !==
              -1 || // search by Code
            item.symbol
              .toLowerCase()
              .indexOf(this.searchQuery.toLowerCase()) !== -1 // search by Symbol
          ) {
            return item;
          }
        });
      } catch (error) {
        return error;
      }
    },
    ...mapState(["mainNav", "allEntCurrencies", "defaultCurrencies"]),
    ...mapGetters(["currencies", "phoneCodes", "defCurrencies"]),
  },
  components: {
    "dashboard-nav": dashboard_Nav,
    "main-nav": main_Nav,
    breadcrumb: bread_crumb,
    "inner-page-loader": inner_page_loader,
  },
};
</script>

<style scoped>
.table-menu {
  width: 96%;
  margin-left: 2%;
  margin-right: 2%;
}
.table-menu .table-col2 {
  width: 40%;
}

.image {
  width: 130px;
}

.item_status_icon {
  color: green;
}
</style>
